import { z } from 'zod';

export const ImputationSchema = z
  .object({
    sub_account_ids: z.array(z.coerce.number().int().positive()).max(500).optional(),
    /** When true, consolidate every sub-account of the master (ys142857 sub_list 一键归集). */
    impute_all: z.boolean().optional(),
    asset_filter: z.enum(['all', 'ep1', 'ep2', 'uo', 'mp']),
    transaction_password: z.string().min(1).max(128),
    security_answer: z.string().min(1).max(256),
  })
  .refine((v) => v.impute_all === true || (v.sub_account_ids?.length ?? 0) >= 1, {
    message: 'sub_account_ids or impute_all required',
  });

export type ImputationRequest = z.infer<typeof ImputationSchema>;
